import {
  REQUEST_DATA,
  RECEIVE_DATA,
  REQUEST_TEAM_DATA,
  RECEIVE_TEAM_DATA,
  REQUEST_ARCHIVE_DATA,
  RECEIVE_ARCHIVE_DATA,
  REQUEST_SEMPAI2017_DATA,
  RECEIVE_SEMPAI2017_DATA,
  // MINIMIZE,
  MENU_STATE,
  FOOTER_STATE,
  HEADER_STATE,
  IS_NAVIGATE_GALLERY,
  INFO_CAMP_2016,
  REQUEST_MENU,
  RECEIVE_MENU,
  REQUEST_ALERT,
  RECEIVE_ALERT,
  TOGGLE_ANSWER,
  TOGGLE_IMAGE_GRID,
  MINIMIZE_ALERT,
  HIDE_ALERT,
  TOGGLE_MODAL,
  SELECT_USER,
  // examples:
  REQUEST_TOKEN_INIT,
  REQUEST_TOKEN_PERMISSION_FETCHLIST,
  RECEIVE_TOKEN_PERMISSION_FETCHLIST,
  REQUEST_TOKEN_PERMISSION_ADD,
  RECEIVE_TOKEN_PERMISSION_ADD,
  REQUEST_TOKEN_PERMISSION_DELETE,
  RECEIVE_TOKEN_PERMISSION_DELETE,
  REQUEST_TOKEN_FETCHLIST,
  RECEIVE_TOKEN_FETCHLIST,
  REQUEST_TOKEN_ADD,
  RECEIVE_TOKEN_ADD,
  REQUEST_TOKEN_REVOKE,
  RECEIVE_TOKEN_REVOKE,
  REQUEST_TOKEN_SYNC,
  RECEIVE_TOKEN_SYNC,
  REQUEST_TOKEN_FETCH,
  RECEIVE_TOKEN_FETCH
} from 'actions/token'
import _ from 'lodash'
import update from 'react-addons-update'

function reducer(state = {
  error:null,
  list:null,
  objects:{},
  cursor:null
}, action) {
  switch (action.type) {
    case REQUEST_DATA:
      return Object.assign({}, state, {
        isFetching: true,
        data: null
      })
    case RECEIVE_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data
      })
    case REQUEST_TEAM_DATA:
      return Object.assign({}, state, {
        fetchingTeamData: true
      })
    case RECEIVE_TEAM_DATA:
      return Object.assign({}, state, {
        fetchingTeamData: false,
        teamData: action.teamData
      })
    case REQUEST_ARCHIVE_DATA:
      return Object.assign({}, state, {
        fetchingArchiveData: true
      })
    case RECEIVE_ARCHIVE_DATA:
      return Object.assign({}, state, {
        fetchingArchiveData: false,
        archiveData: action.archiveData
      })
    case REQUEST_SEMPAI2017_DATA:
      return Object.assign({}, state, {
        fetchingSempai2017Data: true
      })
    case RECEIVE_SEMPAI2017_DATA:
      return Object.assign({}, state, {
        fetchingSempai2017Data: false,
        sempai2017Data: action.sempai2017Data
      })
    case MENU_STATE:
      return Object.assign({}, state, {
        menuState: action.menuState
      })
    case FOOTER_STATE:
      return Object.assign({}, state, {
        footerIsHidden: action.footerIsHidden
      })
    case HEADER_STATE:
      return Object.assign({}, state, {
        headerIsHidden: action.headerIsHidden
      })
    case IS_NAVIGATE_GALLERY:
      return Object.assign({}, state, {
        isNavigateGallery: action.isNavigateGallery
      })
    case INFO_CAMP_2016:
      return Object.assign({}, state, {
        infoCamp2016: action.infoCamp2016
      })
    case REQUEST_MENU:
      return Object.assign({}, state, {
        isFetchingMenu: true
      })
    case RECEIVE_MENU:
      return Object.assign({}, state, {
        isFetchingMenu: false,
        menuData: action.menuData
      })
    case REQUEST_ALERT:
      return Object.assign({}, state, {
        isFetchingAlert: true
      })
    case RECEIVE_ALERT:
      return Object.assign({}, state, {
        isFetchingAlert: false,
        alertData: action.alertData
      })
    case TOGGLE_ANSWER:
      return Object.assign({}, state, {
        questionId: action.questionId
      })
    case TOGGLE_IMAGE_GRID:
      return Object.assign({}, state, {
        canSeeImageGrid: action.canSeeImageGrid
      })
    case MINIMIZE_ALERT:
      return Object.assign({}, state, {
        alertIsMinimized: action.alertIsMinimized
      })
    case HIDE_ALERT:
      return Object.assign({}, state, {
        alertIsHidden: action.alertIsHidden
      })
    case TOGGLE_MODAL:
      return Object.assign({}, state, {
        modalState: action.modalState
      })
    case SELECT_USER:
      return Object.assign({}, state, {
        selectedUser: action.userId
      })

    // examples:
    case REQUEST_TOKEN_INIT:
      return Object.assign({}, state, {
        error:null,
        list:null,
        objects:{},
        cursor:null
      })
    case REQUEST_TOKEN_ADD:
      return Object.assign({}, state, {
        error:null
      })
    case RECEIVE_TOKEN_ADD:
      {
        let response = action.response || {}
        let success = response.status === 200
        let body = response.body
        if(!success) {
          return Object.assign({}, state, {
            error:body
          })
        }
        return Object.assign({}, state, {
          list:update(state.list, {
            $unshift:[body.token]
          })
        })
      }
    case REQUEST_TOKEN_PERMISSION_ADD:
      return Object.assign({}, state, {
        error:null
      })
    case RECEIVE_TOKEN_PERMISSION_ADD:
      {
        let response = action.response || {}
        let success = response.status === 200
        let body = response.body
        if(!success) {
          return Object.assign({}, state, {
            error:body
          })
        }
        if(!state.objects) {
          return Object.assign({}, state, {
          })
        }
        let object = state.objects[action.request.ID]
        let newObjects = {}
        newObjects[object.ID] = update(object, {
          permissions:object.permissions ? {$unshift:[body.permission]} : {$set:[body.permission]}
        })
        return Object.assign({}, state, {
          objects:update(state.objects, {
            $merge:newObjects
          })
        })
      }
    case REQUEST_TOKEN_PERMISSION_DELETE:
      return Object.assign({}, state, {
        error:null
      })
    case RECEIVE_TOKEN_PERMISSION_DELETE:
      {
        let response = action.response || {}
        let success = response.status === 200
        let body = response.body
        if(!success) {
          return Object.assign({}, state, {
            error:body
          })
        }
        if(!state.objects) {
          return Object.assign({}, state, {
          })
        }
        let object = state.objects[action.request.ID]
        let newObjects = {}
        newObjects[object.ID] = update(object, {
          permissions:{$set:object.permissions.filter(permission => {
            return permission.ID === body.permission.ID ? null : permission
          })}
        })
        return Object.assign({}, state, {
          objects:update(state.objects, {
            $merge:newObjects
          })
        })
      }
    case REQUEST_TOKEN_REVOKE:
      return Object.assign({}, state, {
        error:null
      })
    case RECEIVE_TOKEN_REVOKE:
      {
        let response = action.response || {}
        let success = response.status === 200
        let body = response.body
        if(!success) {
          return Object.assign({}, state, {
            error:body
          })
        }
        let newList = (state.list || []).filter(token => {
          return token.ID === body.token.ID ? null : token
        })
        let object = body.token
        let newObjects = {}
        newObjects[object.ID] = object
        return Object.assign({}, state, {
          list:newList,
          objects:update(state.objects, {
            $merge:newObjects
          })
        })
      }
    case REQUEST_TOKEN_SYNC:
      return Object.assign({}, state, {
        error:null
      })
    case RECEIVE_TOKEN_SYNC:
      {
        let response = action.response || {}
        let success = response.status === 200
        let body = response.body
        if(!success) {
          return Object.assign({}, state, {
            error:body
          })
        }
        if(action.request.ID) {
          let object = body.token
          let newObjects = {}
          newObjects[object.ID] = object
          return Object.assign({}, state, {
            objects:update(state.objects, {
              $merge:newObjects
            })
          })
        } else {
          let newList = _.uniqBy((body.tokens).concat(state.list || []).sort((a, b) => {
            return b.ctime - a.ctime
          }), 'ID')
          return Object.assign({}, state, {
            cursor:body.cursor,
            list: newList
          })
        }
      }
    case REQUEST_TOKEN_FETCH:
      return Object.assign({}, state, {
        error:null
      })
    case RECEIVE_TOKEN_FETCH:
      {
        let response = action.response || {}
        let success = response.status === 200
        let body = response.body
        if(!success) {
          return Object.assign({}, state, {
            error:body
          })
        }
        let object = body.token
        let newObjects = {}
        newObjects[object.ID] = object
        return Object.assign({}, state, {
          objects:update(state.objects, {
            $merge:newObjects
          })
        })
      }
    case REQUEST_TOKEN_PERMISSION_FETCHLIST:{
      return Object.assign({}, state, {
        error:null
      })
    }
    case RECEIVE_TOKEN_PERMISSION_FETCHLIST:{
      let response = action.response || {}
      let success = response.status === 200
      let body = response.body
      if(!success) {
        return Object.assign({}, state, {
          error:body
        })
      }
      if(!state.objects) {
        return Object.assign({}, state, {
        })
      }
      let object = state.objects[action.request.ID]
      let newObjects = {}
      newObjects[object.ID] = update(object, {
        permissionscursor:{$set:body.cursor},
        permissions:object.permissions ? {$push:body.permissions} : {$set:body.permissions}
      })
      return Object.assign({}, state, {
        objects:update(state.objects, {
          $merge:newObjects
        })
      })
    }
    case REQUEST_TOKEN_FETCHLIST:
      return Object.assign({}, state, {
        error:null
      })
    case RECEIVE_TOKEN_FETCHLIST:
      {
        let response = action.response || {}
        let success = response.status === 200
        let body = response.body
        if(!success) {
          return Object.assign({}, state, {
            error:body
          })
        }
        let newList = _.uniqBy((body.tokens).concat(state.list || []).sort((a, b) => {
          return b.ctime - a.ctime
        }), 'ID')
        return Object.assign({}, state, {
          cursor:body.cursor,
          list: newList
        })
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/token.js